import React, { Component } from "react";
import "./App.css";
import routes from "./routes";
import withRouter from "./components/withRouter";
import { Route, Routes, Navigate } from "react-router-dom";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <React.Fragment>
        <Routes>
          {routes.map((route, idx) => (
            <Route path={route.path} element={route.component} key={idx} />
          ))}
          {/* Redirect any other paths to the index page */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </React.Fragment>
    );
  }
}

export default withRouter(App);
